<script setup lang="ts">
import BaseButton from './BaseButton.vue';

interface Props {
  size?: 'small' | 'large';
  htmlType?: 'button' | 'submit' | 'reset';
  loading?: boolean;
  disabled?: boolean;
  block?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  size: 'large',
  htmlType: 'button',
  loading: false,
  disabled: false,
  block: false,
});
</script>

<template>
  <BaseButton v-bind="props" type="text" class="button-text" :size="size">
    <slot></slot>
    <template v-for="slotName in Object.keys($slots)" #[slotName]>
      <slot :name="slotName"></slot>
    </template>
  </BaseButton>
</template>

<style lang="less" scoped>
.button-text {
  color: @color-primary;
}

.ant-btn-text:hover,
.ant-btn-text:active {
  color: @color-primary;
  background-color: @color-mid-tone;
}
</style>
